import script from "./pc-module-case-4.vue?vue&type=script&setup=true&lang=tsx"
export * from "./pc-module-case-4.vue?vue&type=script&setup=true&lang=tsx"

import "./pc-module-case-4.vue?vue&type=style&index=0&id=778d0eda&lang=scss"

const __exports__ = script;

export default __exports__